// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__20MBD","content":"RecentSearches_content__1OMKB"};